import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { nullSafe } from 'Utility/globalMethods'
import * as ResultsActions from '../../modules/ResultsActions'
import PaymentsDetail from './PaymentsDetail'
import { doHidePopup, doShowPopup } from 'Store/actions/popup'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(ResultsActions, dispatch),
  ...bindActionCreators({ doShowPopup }, dispatch),
  doClosePopup: (type) => dispatch(doHidePopup(type))
})

const mapStateToProps = (state) => ({
  tabSelected: nullSafe(() => state.Results.tabSelected, 'ONE_PERIOD'),
  groupByCardBrand: nullSafe(() => state.Results.groupByCardBrand, {}),
  referredPeriod: nullSafe(() => state.Results.referredPeriod, [])
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(PaymentsDetail)
